<template>
<div>
  <div class="mainLoader" v-if="loading"></div>
    <div class="realbody">
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-12 text-left">
            <div @click="goBack()" v-if="this.history > 1" class="btn skywhitebtn backbtn mplus2p-r">
              <img style="float: left; margin-top: 2px;" src="../../assets/imgs/backarrow.png" />
              {{$t('back_chat_list')}}
            </div>
          </div>

          <!--  -->
          <div class="col-md-12" style="margin: 27px">
            <div class="row pl-2">
              <div class="col-2 px-0">
                <img class="small_tip1 d-block mx-auto" src="../../assets/imgs/e3.png" />
              </div>
              <div class="col-10 px-0 my-auto">
                {{message.subject}}
              </div>
            </div>
          </div>
        </div>

        <!--  -->
        <div class="col chathistory" style="margin: 27px">
          <div class="row pl-2">
            <div class="col-2">
              <img class="small_tip1 d-block mx-auto" src="../../assets/imgs/default-user.png" />
              <span class="mt-1 d-block text-center">{{$t('notice_from_the_management')}}</span>
            </div>
            <div class="col  p-1 bg-primary-light">
              <span class="d-block" v-html="message.message"></span>
              <div class="mt-auto" v-if="message.user && message.user.company">
                <span> --- </span>
                <span>{{message.user.company.name}}</span>
                <!-- <span v-if="message.user.company">{{message.user.company.email}}</span> -->
              </div>
            </div>
            <div class="col-auto">
                <div class="text-right chatdate">
                  <u>{{message.time}}</u>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
import axios from "axios";
export default {
  data() {
    return {
      loading: true,
      history: "",
      lan: "jp",
      message: {},
    };
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    this.history = window.history.length;
  }, 
  mounted() {
     axios
        .get("/get-message/" + this.$route.params.messageId +"?token=" + localStorage.getItem("token"), {
          headers: { "X-localization": localStorage.getItem("lan") }
        }).then(res=> {
            this.message = res.data
        }).catch(error => {
          console.log(error)
        }).finally(()=> {
          this.loading = false
        })
  },
  methods: {
      goBack() {
        this.$router.push("/engineer/chataction-list");
    },
  }
};
</script>

<style scoped>
.bg-primary-light {
  background-color: rgba(61, 125, 216, 0.16)
}
.tech2 {
  margin-right: 5px;
  margin-bottom: 10px;
}
.layer2 {
  width: fit-content;
  background-color: #3d7dd8;
  font-size: 1rem;
  text-align: center;
  font-family: mplus2-m;
  font-weight: 400;
  letter-spacing: 1.2px;
  color: #fff;
  padding: 8px;
  margin-right: 5px;
  margin-bottom: 20px;
  border-radius: 15px;
  display: block;
}
.engineerDetail {
  cursor: pointer;
}
.companyDetail {
  cursor: pointer;
}
.rounded-circle1 {
  margin-top: 15px;
  border-radius: 100%;
}
.download-file {
  font-size: 13px;
}
.rounded-circle {
  margin-top: 15px;
  border-radius: 100%;
}
.left {
  margin-top: 15px !important;
  border-radius: 3.2px;
  background-color: rgba(61, 125, 216, 0.08);
  /* color: #3d7dd8; */
  font-size: 1em;
  font-weight: 500;
  padding: 4px 8px;
  margin-left: 5px;
  float: left;
  cursor: pointer;
}

.right {
  margin-top: 15px !important;
  border-radius: 3.2px;
  background-color: rgba(61, 125, 216, 0.08);
  color: #3d7dd8;
  font-size: 1em;
  font-weight: 500;
  padding: 4px 8px;
  margin-left: 5px;
  float: right;
  cursor: pointer;
}

.backbtn {
  width: 240px;
  height: 48px;
  border-radius: 8px;
  margin-top: 50px;
  padding-top: 13px;

  font-size: 1rem;
  font-weight: bold;
}

.chattitle {
  font-size: 1.5rem;
  font-weight: 500;
  margin-top: 42px;
}

.chathistory {
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(60, 80, 100, 0.12);
  background-color: #ffffff;
  border: solid 1px #e8eaee;

  padding: 10px 5px;
  margin: 0;
  margin-bottom: 18px;
}

.small_tip {
  width: 100px;
  height: 100px;
  object-position: center;
  border-radius: 100%;
}
.small_tip1 {
  width: 125px;
  object-position: center;
}

.big_tip {
  width: 125px;
  height: 125px;
}

.targettitle {
  position: absolute;
  font-size: 0.875rem;
  font-weight: 500;
  margin-left: 10px;
  margin-top: 50px;
}
.ccontents {
  word-break: break-all;
}
.chatdate {
  font-size: 0.75rem;
}

.chatmanstatus {
  font-size: 0.625rem;
  margin-left: 4px;
}

.chatmantitle {
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: underline;
}

.chatmancontents {
  font-size: 1rem;
  font-weight: 500;
  line-height: 2;
  margin-top: 10px;
}

.chattextarea {
  border-radius: 4px;
  background-color: #f0f2f4;
  border: solid 1px #e6e8ea;
  width: 100%;
  height: 140px;
}

.chatinputbody {
  margin-top: 40px;
}

.attachement {
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 2px #e6e8ea;
  width: 100%;
  margin-top: -7px;
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 8px;
}

.chosenfile_title {
  font-size: 0.875rem;
  font-weight: 500;
}
.chosenfile_title2 {
  font-size: 0.675rem;
  font-weight: 500;
}
.input.invalid label {
  color: red;
}

.input.invalid input {
  border: 1px solid red;
  background-color: #ffc9aa;
}
.input.invalid select {
  border: 1px solid red;
  background-color: #ffc9aa;
}
.input.invalid textarea {
  border: 1px solid red !important;
  background-color: #ffc9aa !important;
}
.thelast {
  margin-top: 30px;
}

.sendbtn {
  width: 100%;
  height: 56px;
}

@media screen and (max-width: 992px) {
  .chatbody {
    padding: 0px 40px;
  }
}

@media screen and (max-width: 768px) {
  .chatbody {
    padding: 10px 15px;
  }

  .chosenfile_title {
    margin-left: 15px;
  }
}
</style>
